import React, { useRef } from "react";
import { DataGrid } from "devextreme-react";
import { Item } from "devextreme-react/form";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Popup, Form, RequiredRule, StringLengthRule } from "devextreme-react/data-grid";
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";

const Roles = props => {

    let dataGrid = useRef();

    const onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar nuevo',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => dataGrid.current.instance.addRow()
            }
        });
    }

    const title = "Perfiles";

    return (
        <div className="container small">
            <Title title={title} />
            <BlockHeader title={title} />
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: { get: uri.roles.get, insert: uri.roles.insert } })}
                showBorders={true}
                showRowLines={true}
                onToolbarPreparing={onToolbarPreparing}               
            >
                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowDeleting={false}
                    useIcons={true}
                >
                    <Popup width={300} height={200}>
                    </Popup>
                    <Form colCount={1}>
                        <Item dataField="name" >
                            <RequiredRule message="El nombre de rol es requerido" />
                            <StringLengthRule max={50} min={5} message="Máximo de caracteres 50 y 2 mínimo" />
                        </Item>                       
                    </Form>
                </Editing>
                <Column dataField="id" caption="Id" width={60} visible={false} allowEditing={false} />
                <Column dataField="name" caption="Nombre" />
            </DataGrid>
        </div>
    );
}

export default Roles;